import { Component } from '@angular/core';
import * as XLSX from 'xlsx';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-bdc',
  templateUrl: './bdc.component.html',
  styleUrls: ['./bdc.component.scss']
})
export class BdcComponent {

  constructor(public api:ApiService) { 
  }

  prodNotImported:any;

  displayForImport = false;

  importBdc(event) {
    try {
      // PrimeNG FileSelectEvent : currentFiles / files (pas un DataTransfer natif)
      const file =
        (event && event.currentFiles && event.currentFiles[0]) ||
        (event && event.files && event.files[0]) ||
        (event && event.target && event.target.files && event.target.files[0]);

      if (!file) {
        this.api.error('Aucun fichier sélectionné.');
        return;
      }

      if (!this.api.games || this.api.games.length === 0) {
        this.api.error('Catalogue non chargé. Attendez la fin du chargement client puis réessayez.');
        return;
      }

      for (let p of this.api.order.prods) {
        p.quantity = 0;
        this.api.changeQty(p);
      }
      this.api.order.prods = [];
      localStorage.removeItem('brgProOrder');

      this.prodNotImported = [];

      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true });

          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          let data = XLSX.utils.sheet_to_json(ws, { range: 11 });
          let imported = 0;

          for (let row of data) {
            row['Quantité commandée'] = parseInt(row['Quantité commandée'], 10);

            const ref =
              row['Référence'] != null && row['Référence'] !== ''
                ? String(row['Référence']).trim()
                : '';

            if (
              ref &&
              row['Désignation'] != '' &&
              typeof row['Quantité commandée'] == 'number' &&
              !isNaN(row['Quantité commandée']) &&
              row['Quantité commandée'] > 0
            ) {
              let prod = this.api.games.find((item) => {
                return item.Id == ref;
              });
              if (prod != undefined) {
                imported++;
                prod.quantity = row['Quantité commandée'];
                prod.checked = true;
                setTimeout(() => {
                  this.api.addToCart(prod);
                  setTimeout(() => {
                    if (row['Démo à 50%'] > 0) {
                    }
                    if (row['Démo à 30%'] > 0) {
                      this.chooseOffer(this.api.offers[2], prod);
                    }
                  }, 110);
                }, 100);
              } else {
                this.prodNotImported.push(row);
              }
            }
          }

          if (this.prodNotImported.length > 0) {
            this.displayForImport = true;
          }

          if (imported === 0) {
            this.api.warning(
              'Aucun article importé. Vérifiez le format du fichier (références / quantités).'
            );
          } else {
            this.api.success(imported + ' article(s) importé(s).');
          }
        } catch (err) {
          console.error(err);
          this.api.error("Erreur lors de la lecture du bon de commande.");
        }
      };
      reader.onerror = () => {
        this.api.error('Impossible de lire le fichier.');
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      console.error(err);
      this.api.error("Erreur lors de l'import du bon de commande.");
    }
  }


  chooseOffer(offer,prod){
    if (!offer || !prod) {
      return;
    }
    let o = Object.assign({}, offer);
    let gameInCart = this.api.order.prods.find(item=>item.id === prod.idInCart);
    if (!gameInCart) {
      return;
    }
    if (!gameInCart.authorizedOffers) {
      gameInCart.authorizedOffers = [];
    }
    gameInCart.authorizedOffers.push(offer.id_offer);
    if (!o.acceptedForProds) {
      o.acceptedForProds = [];
    }
    o.acceptedForProds.push(gameInCart.Id);
    this.api.changeQty(gameInCart);
  }
}
